import React, { useEffect, useState } from 'react'
import { Col, Row, Skeleton } from 'antd'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { RootState } from '../../../../../store/store'
import { useSelector } from 'react-redux'
import { getCurriculum } from '../../../../../api/curriculum/curriculum'
import Modulegroup from './modulegroup/modulegroup'
import { openNotificationWithIcon } from '../../../../../utils/helper'


const Teachercurriculum = () => {
	const navigate = useNavigate()
	const { pathname } = useLocation()
	const { curriculumId } = useParams()

	const [loading, setLoading] = useState(false)
	const [curriculum, setCurriculum] = useState<any>({

	})
	const [data, setData] = useState<any[]>([])

	const state = useSelector((state: RootState) => ({
		user: state.user.user,
	}))

	const { user } = state

	useEffect(() => {
		navigate(`${pathname}`, {
			state: {
				pageName: 'Curriculum',
			}
		})

		// eslint-disable-next-line
	}, [])

	const fetchCurriculum = async () => {
		try {
			setLoading(true)
			const res = await getCurriculum(curriculumId || '')
			const { data } = res?.data
			setCurriculum(data)
			const newData: any[] = []
			data.modules.forEach((item: any, index: number) => {
				let obj = {
					...item,
					open: index === 0 ? true : false,
				}
				newData.push(obj)
			})
			setData(newData)
			setLoading(false)
		} catch (error: any) {
			setLoading(false)
			if (error?.response) {
				openNotificationWithIcon('error', 'Get Curriculum', `${error?.response?.data?.message || 'Something went wrong'}`)
			} else {
				openNotificationWithIcon('error', 'Get Curriculum', 'Something went wrong')
			}
			navigate(`/teacher/dashboard/curricula`)
		}
	}

	useEffect(() => {
		fetchCurriculum()

		// eslint-disable-next-line
	}, [])


	const openLevel = (levelIndex: number, value: boolean) => {
		let updatedLevels: any = [...data]
		let newLevels = updatedLevels.map((item: any, index: number) => {
			if (index === levelIndex) {
				return {
					...item,
					open: value
				}
			}

			return {
				...item,
				open: false
			}
		})

		setData(newLevels)
	}

	return (
		<div className='h-screen pr-10 mt-4'>
			<Row gutter={32}>
				<Col xs={24} md={24} lg={15}>
					<div>
						<p className='text-lg font-[900] text-appcolorpurplefaintone capitalize'>
							{
								loading ?
									<Skeleton.Button
										active={true}
										size={'large'}
										shape={'square'}
										block={true}
										style={{
											height: '2rem',
											width: '6rem'
										}}
									/>
									:
									curriculum?.name
							}
						</p>

						<div className='pt-4 mt-4 border-t-[0.3px] border-appcolorpurplefaintone flex w-full'>
							<Row gutter={8} className="w-full">
								<Col xs={24} md={24} lg={12}>
									{
										loading ?
											<Skeleton.Button
												active={true}
												size={'large'}
												shape={'square'}
												block={true}
												style={{
													height: '2rem',
													width: '13rem',
													marginBottom: '1rem'
												}}
											/>
											:
											<div className='flex items-center mb-2'>
												<img src="/img/vectors/purpletime.svg" alt="users" className='w-5 h-5 mr-1' />

												<div className='flex items-center'>
													<p className='pr-1 text-base font-extrabold text-appcolorpurplefaintone'>{curriculum?.duration}</p>
													<p className='text-sm text-appcolorpurplefaintone'>{curriculum?.durationUnit}{curriculum?.duration > 1 ? 's' : ''}</p>
												</div>
											</div>
									}

								</Col>

								<Col xs={24} md={24} lg={12}>
									{
										loading ?
											<Skeleton.Button
												active={true}
												size={'large'}
												shape={'square'}
												block={true}
												style={{
													height: '2rem',
													width: '13rem',
													marginBottom: '1rem'
												}}
											/>
											:
											<div className='flex items-center mb-2'>
												<img src="/img/vectors/purpleminmod.svg" alt="users" className='w-5 h-5 mr-1' />

												<div className='flex items-center'>
													<p className='pr-1 text-base font-extrabold text-appcolorpurplefaintone'>2</p>
													<p className='text-sm text-appcolorpurplefaintone'>min/module</p>
												</div>
											</div>
									}
								</Col>

								<Col xs={24} md={24} lg={12}>

									{
										loading ?
											<Skeleton.Button
												active={true}
												size={'large'}
												shape={'square'}
												block={true}
												style={{
													height: '2rem',
													width: '13rem',
													marginBottom: '1rem'
												}}
											/>
											:
											<div className='flex items-center mb-2'>
												<img src="/img/vectors/purpledocument.svg" alt="users" className='w-5 h-5 mr-1' />

												<div className='flex items-center'>
													<p className='pr-1 text-base font-extrabold text-appcolorpurplefaintone'>0</p>
													<p className='text-sm text-appcolorpurplefaintone'>assignments</p>
												</div>
											</div>
									}

								</Col>

								<Col xs={24} md={24} lg={12}>
									{
										loading ?
											<Skeleton.Button
												active={true}
												size={'large'}
												shape={'square'}
												block={true}
												style={{
													height: '2rem',
													width: '13rem',
													marginBottom: '1rem'
												}}
											/>
											:
											<div className='flex items-center'>
												<img src="/img/vectors/purpleplans.svg" alt="users" className='w-5 h-5 mr-1' />
												<div className='flex items-center'>
													<p className='pr-1 text-base font-extrabold text-appcolorpurplefaintone'>{curriculum?.lessonPlans?.length}</p>
													<p className='text-sm text-appcolorpurplefaintone'>lesson plan{curriculum?.lessonPlans?.length > 1 ? 's' : ''}</p>
												</div>
											</div>
									}

								</Col>

								<Col xs={24} md={24} lg={12}>
									{
										loading ?
											<Skeleton.Button
												active={true}
												size={'large'}
												shape={'square'}
												block={true}
												style={{
													height: '4rem',
													width: '20rem',
													marginBottom: '1rem'
												}}
											/>
											:
											<div className='flex items-center mt-[1.4rem]'>
												<div className='custom-piped custom-piped-curicard pr-[0.6rem]'>
													{
														user?._id === curriculum?.createdBy ?
															<>
																<img src={`${user?.userAvatarURL === undefined ?
																	'/img/vectors/usertag.svg'
																	:
																	user?.userAvatarURL === '' ?
																		'/img/vectors/usertag.svg' :
																		user?.userAvatarURL
																	}`}
																	alt="usertag"
																	className='w-6 h-6 rounded-full'
																/>
															</>
															:
															<>
																<img src="/img/logo/cfhcircle.svg" alt="cfhcircle" className='w-6 h-6 border rounded-full border-appcolororangethree' />
															</>
													}
												</div>

												<div className='ml-[0.6rem] flex items-center justify-between flex-grow'>
													<div className='flex flex-col'>
														<p className='text-xs text-appcolorpurplefaintone'>Created by</p>
														<p className='text-base font-extrabold text-appcolorpurplefaintone'>
															{
																user?._id === curriculum?.createdBy ? `${user.userName}` : 'CFH'
															}
														</p>
													</div>
												</div>
											</div>
									}

								</Col>
								<Col xs={24} md={24} lg={12}>
									{
										loading ?
											<Skeleton.Button
												active={true}
												size={'large'}
												shape={'square'}
												block={true}
												style={{
													height: '4rem',
													width: '20rem',
													marginBottom: '1rem'
												}}
											/>
											:
											<div className='flex flex-col mt-[1.4rem]'>
												<p className='text-xs text-appcolorpurplefaintone'>Assigned to</p>
												<div className='flex items-center'>
													<img src="/img/vectors/curicullumusers.svg" alt="users" className='w-6 h-6' />
													<p className='pr-1 text-lg font-extrabold text-appcolorpurplefaintone'>2</p>
													<p className='text-sm text-appcolorpurplefaintone'>Classes</p>
												</div>
											</div>
									}
								</Col>
							</Row>
						</div>

						<div className='mt-10'>
							{
								loading ?
									<>
										{
											[1, 2, 3, 4, 5].map((item) => (
												<div key={`loading-modules-${item}`}>
													<Skeleton.Button
														active={true}
														size={'large'}
														shape={'square'}
														block={true}
														style={{
															height: '4rem',
															marginBottom: '1rem',
															borderRadius: '1rem',
															marginRight: '1rem',
															width: '100%'
														}}
													/>
												</div>
											))
										}
									</>
									:
									<div className='max-h-screen min-h-full overflow-auto '>
										{
											data.map((item: any, index: number) => (
												<Modulegroup
													key={item?._id}
													details={item}
													index={index}
													openLevel={openLevel}
												/>
											))
										}
									</div>
							}
						</div>
					</div>
				</Col>

				<Col xs={24} md={24} lg={9}>
					<div>
						<p className='text-lg font-[900] text-appcolorpurplefaintone capitalize'>Assigned to</p>

						<div className='pt-4 mt-4 border-t-[0.3px] border-appcolorpurplefaintone flex w-full'>

							{
								loading ?
									<div className='flex flex-col w-full'>
										{
											[12].map((item) => (
												<div key={`loading-assignedclasses-${item}`} className='w-full'>
													<Skeleton.Button
														active={true}
														size={'large'}
														shape={'square'}
														block={true}
														style={{
															height: '4rem',
															marginBottom: '1rem',
															borderRadius: '1rem',
															width: '100%'
														}}
													/>
												</div>
											))
										}
									</div>
									:
									<>
										<div className='flex items-center justify-between w-full'>
											<div className="flex items-center">
												<div className='custom-piped custom-piped-curicard pr-[0.6rem]'>
													{
														user?._id === curriculum?.createdBy ?
															<>
																<img src={`${user?.userAvatarURL === undefined ?
																	'/img/vectors/usertag.svg'
																	:
																	user?.userAvatarURL === '' ?
																		'/img/vectors/usertag.svg' :
																		user?.userAvatarURL
																	}`}
																	alt="usertag"
																	className='w-6 h-6 rounded-full'
																/>
															</>
															:
															<>
																<img src="/img/logo/cfhcircle.svg" alt="cfhcircle" className='w-6 h-6 border rounded-full border-appcolororangethree' />
															</>
													}
												</div>
												<div className='ml-[0.6rem] flex items-center justify-between flex-grow'>
													<div className='flex flex-col'>
														<p className='text-base font-medium text-appcolorpurplefaintone'>Primary 6A</p>
													</div>
												</div>
											</div>

											<div className='flex flex-col items-end'>
												<p className='text-xs text-appcolorpurplefaintone'>Assigned to</p>
												<div className='flex items-center'>
													<img src="/img/vectors/curicullumusers.svg" alt="users" className='w-6 h-6' />
													<p className='pr-1 text-base font-extrabold text-appcolorpurplefaintone'>2</p>
													<p className='text-sm text-appcolorpurplefaintone'>Students</p>
												</div>
											</div>
										</div>
									</>
							}
						</div>


						<div className='mt-[8rem] pl-14 border-l border-appcolorpurplefaintone h-screen'>
							<div className='flex items-center justify-center mb-5 p-[0.93rem] rounded-3xl custom-yellow-faint-two h-[4.6rem] cursor-pointer'>
								<img src="/img/vectors/viewlessonplan.svg" alt="viewlessonplan" className='mr-2' />
								<p className='text-base text-appcolordeeptan'>
									View Lesson Plans
								</p>
							</div>

							<div className='flex items-center justify-center p-[0.93rem] rounded-3xl custom-purple-bg-linear h-[4.6rem] cursor-pointer'>
								<img src="/img/vectors/purpleshare.svg" alt="purpleshare" className='mr-2' />
								<p className='text-base text-appcolordeeppurpletwo'>
									Share this curriculum
								</p>
							</div>

						</div>
					</div>
				</Col>
			</Row>

		</div>
	)
}

export default Teachercurriculum